/**
 * MediaGallery — galerie d'images cliquables (lightbox via callback).
 *
 *   <MediaGallery
 *     items={displayMedia.map(m => ({ id: m.id, minioKey: m.minio_key }))}
 *     alt={work.title_fr}
 *     onSelect={(item) => setLightboxKey(item.minioKey)}
 *   />
 *
 * Layout : 1 image principale (4/5 portrait) + grille 2-col de thumbs.
 * S2.4 = MediaGallery local (placée dans `components/ui/` pour respecter
 * `no-raw-html-controls` qui exempte ce dossier — extraction propre dans
 * `components/media/` prévue S4 quand mockups réutilisera la primitive).
 */

import MediaImage from './MediaImage'

import './MediaGallery.css'

export interface MediaGalleryItem {
  id: number | string
  minioKey: string
}

interface MediaGalleryProps {
  items: MediaGalleryItem[]
  alt: string
  onSelect?: (item: MediaGalleryItem) => void
  className?: string
}

export default function MediaGallery({ items, alt, onSelect, className }: MediaGalleryProps) {
  if (items.length === 0) return null

  const [main, ...thumbs] = items
  const classes = ['media-gallery', thumbs.length === 0 ? 'media-gallery--single' : null, className]
    .filter(Boolean)
    .join(' ')

  return (
    <section className={classes} aria-label="Galerie d'images">
      <button
        type="button"
        className="media-gallery-main"
        onClick={() => onSelect?.(main)}
        aria-label="Agrandir l'image principale"
      >
        <MediaImage minioKey={main.minioKey} alt={alt} />
      </button>
      {thumbs.length > 0 && (
        <ul className="media-gallery-thumbs" role="list">
          {thumbs.map((m) => (
            <li key={m.id}>
              <button
                type="button"
                className="media-gallery-thumb"
                onClick={() => onSelect?.(m)}
                aria-label="Agrandir cette image"
              >
                <MediaImage minioKey={m.minioKey} alt={alt} />
              </button>
            </li>
          ))}
        </ul>
      )}
    </section>
  )
}
